import { defineStore } from "pinia";
import * as jose from "jose";

export const useUserStore = defineStore({
  id: "user",
  state: () => ({
    tabActive: 0,
    isAlacarteActive: 1,
    user: [],
    loggedIn: false,
    token: "",
    snackbar: false,
    messageSnack: "-",
    snackStatus: "-",
    snackTimeout: 2000,
    snackLocation: "bottom center",
    isSnackCloseable: false,
    pengaturan: [],
    pengaturanmateri: [],
    pengaturanpenguji: [],
    pengaturandiuji: [],
    pengaturanstakeholder: [],
    pengaturanAgendaKelas: [],
    pelatihan: [],
    types: [
      { link: "TatapMaya", id: 1, title: "Tatap Maya" },
      { link: "TugasIndividu", id: 3, title: "Tugas Individu" },
      { link: "TugasKelompok", id: 4, title: "Tugas Kelompok" },
      { link: "TugasMateriIndividu", id: 5, title: "Tugas Materi Individu" },
    ],
  }),
  getters: {
    isAdmin() {
      return this.CekAdmin();
    },
  },
  actions: {
    async loginViaPortal(token) {
      try {
        const nip = jose.decodeJwt(token);
        const response = await fetchData(event, "/auth/login", "POST", {
          username: nip.sub,
          password: nip.sub,
        });

        localStorage.setItem("token", response.data.jwttoken);

        const userStore = useUserStore();

        userStore.$patch({
          pengaturan: {
            pesertaIds: response.data.pesertaIds[0],
          },
        });

        const role = jose.decodeJwt(response.data.jwttoken);
        response.data.userEntity.role = role.authorities[0];

        if (role.authorities) {
          userStore.$patch({
            user: response.data.userEntity,
            token: response.data.jwttoken,
            pelatihan: response.data.pelatihan,
            loggedIn: true,
          });

          await navigateTo({ path: "/pim/Peserta" });
        }
        this.loading = false;
      } catch (error) {
        console.error("Error decoding token:", error.message);
      }
    },
    getTypeById(id) {
      const type = this.types.find((type) => type.id === id);
      return type ? type.title : null;
    },
    cekPath() {
      if (this.CekIsAdmin()) {
        return "admin";
      } else {
        return "pic";
      }
    },
    CekIsAdmin() {
      const role = jose.decodeJwt(this.$state.token);
      const roles = role.authorities;
      if (!roles.includes("ROLE_ADMIN")) {
        return false;
      } else {
        return true;
      }
    },

    CekIsPIC() {
      const role = jose.decodeJwt(this.$state.token);
      const roles = role.authorities;
      if (!roles.includes("ROLE_PIC")) {
        return false;
      } else {
        return true;
      }
    },
    CekAdmin(roleToCheck) {
      // const role = jose.decodeJwt(this.$state.token)
      // const roles = role.authorities;
      // if (!roles.includes('ROLE_ADMIN') || !roles.includes('ROLE_PIC')) {
      //    return false
      // }else{
      //   return true
      // }
      return;
    },
    CekRole(roleToCheck) {
      try {
        const role = jose.decodeJwt(this.$state.token);
        const roles = role.authorities;
        if (!roles.includes(roleToCheck)) {
          return false;
        } else {
          return true;
        }
      } catch (error) {
        return false;
      }
    },
  },
  persist: {
    storage: persistedState.localStorage,
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot));
}
